import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { ScRequirements } from './styled';

export const Requirements = () => {
  const { t } = useTranslation('vip');
  const steps = t('steps.vipTransfer.requirements.steps', {
    returnObjects: true,
  }) as string[];
  return (
    <ScRequirements>
      <span className="title">{t('steps.vipTransfer.requirements.title')}</span>
      <div className="points-wrapper">
        {steps.map((text) => (
          <div className="step" key={text}>
            <ImageComponent
              alt="step"
              height={24}
              src="/icon-img/tickSuccessIcon.svg"
              width={24}
            />
            <span className="text">{text}</span>
          </div>
        ))}
      </div>
    </ScRequirements>
  );
};
